import styled from 'styled-components';
import { GleamMixin } from '../../mixins/components/GleamMixin';
export var StyledGleam = /*#__PURE__*/styled.span.withConfig({
  displayName: "StyledGleam",
  componentId: "c11n-8-107-0__sc-wil507-0"
})(["", ""], GleamMixin);